import { ucfirst, capitalize, truncate, toCurrency, dateCol, booleanToString, asRoundedNumber } from '../utils'

export default {
    install (Vue) {
        Vue.filter('ucfirst', ucfirst);
        Vue.filter('truncate', truncate);
        Vue.filter('capitalize', capitalize);
        Vue.filter('toCurrency', toCurrency);
        Vue.filter('date_col', dateCol);
        Vue.filter('yesno', booleanToString);
        Vue.filter('human_bool', booleanToString);
        Vue.filter('rounded', asRoundedNumber);
    }
}
